import apiClient from './api';
import { Lawyer } from '../types/lawyer'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات المحامي الجديد
export interface NewLawyerData {
  user_id: number;
  name: string;
  specialization: string;
  city: string;
  bar_number: string;
  phone: string;
  email: string;
  join_date: string;
  expiry_date: string;
}

// نوع بيانات التحديث (الحقول اختيارية)
export type UpdateLawyerData = Partial<NewLawyerData>;


export interface LawyerSelectionData {
  id: number;
  name: string;
}

// نوع بيانات المحامي للعرض العام
export interface PublicLawyer {
  id: number;
  name: string;
  specialization: string;
  city: string;
  bar_number: string;
  phone: string;
}

// نوع بيانات لفلاتر البحث
export interface SearchFilters {
  search?: string;
  city?: string;
  specialization?: string;
}

/**
 * [PUBLIC] البحث في دليل المحامين العام
 */
export const searchPublicLawyers = async (filters: SearchFilters): Promise<PublicLawyer[]> => {
  const response = await apiClient.get<{ data: PublicLawyer[] }>('/public/lawyers/search', {
    params: filters,
  });
  return response.data.data;
};

/**
 * جلب قائمة مختصرة بالمحامين لاستخدامها في القوائم المنسدلة
 */
export const getLawyersForSelection = async (): Promise<LawyerSelectionData[]> => {
  const response = await apiClient.get<{ data: LawyerSelectionData[] }>('/lawyers/for-selection');
  return response.data.data;
};
/**
 * جلب قائمة المحامين مع دعم للترقيم والبحث والفرز
 * ملاحظة: ستحتاج إلى إضافة هذه الدالة في lawyer.controller.ts
 */
export const getPagedLawyers = async (params: TableParams): Promise<PagedResult<Lawyer>> => {
  const response = await apiClient.get<{ data: PagedResult<Lawyer> }>('/lawyers/paged', { params });
  return response.data.data;
};

/**
 * إنشاء محامٍ جديد
 */
export const createLawyer = async (lawyerData: NewLawyerData): Promise<Lawyer> => {
  const response = await apiClient.post<{ data: Lawyer }>('/lawyers', lawyerData);
  return response.data.data;
};

/**
 * جلب محامٍ بواسطة ID
 */
export const getLawyerById = async (id: number): Promise<Lawyer> => {
  const response = await apiClient.get<{ data: Lawyer }>(`/lawyers/${id}`);
  return response.data.data;
};

/**
 * تحديث محامٍ موجود
 */
export const updateLawyer = async (id: number, lawyerData: UpdateLawyerData): Promise<Lawyer> => {
  const response = await apiClient.put<{ data: Lawyer }>(`/lawyers/${id}`, lawyerData);
  return response.data.data;
};

/**
 * حذف محامٍ بواسطة ID
 */
export const deleteLawyer = async (id: number): Promise<void> => {
  await apiClient.delete(`/lawyers/${id}`);
};
